import axiosDefault from "../../util/axios";
import { message } from "antd";

import { getAuthorization } from "../../redux/auth/auth.actions";
import { Worker } from "types/worker.types";
import { Workspace } from "../../types/workspace.types";
import { ReportCategory } from "../../components/service/ServiceDashboard/Panel/Panel.types";
import { DayTimes } from "../../types/dayTime.types";

export const fetchWorkerMSTaskRouter = async (uid: string) => {
  try {
    const authorizationToken = await getAuthorization();
    const { data } = await axiosDefault.get(
      `/api/task_router2/worker/external/${uid}`,
      {
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    return data;
  } catch (e) {
    message.error("Login falló, inténtelo nuevamente.");
  }
};

export const fetchWorkersTwilio = async (
  workspace: Workspace
): Promise<Worker[] | undefined> => {
  if (!workspace) {
    return [];
  }
  try {
    const authorizationToken = await getAuthorization();
    const { data } = await axiosDefault.get(
      `/api/task_router2/worker/workspace/${workspace.id}`,
      {
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    const { result } = data;
    return result as Worker[];
  } catch (e) {
    message.error("Falló la búsqueda de workers");
  }
};

export const fetchWorkersBySkills = async (
  workspace: Workspace,
  categories: ReportCategory[]
): Promise<Worker[] | undefined> => {
  if (!workspace) {
    return [];
  }
  try {
    const authorizationToken = await getAuthorization();
    let expression = "";
    for (let i = 0; i < categories.length; i++) {
      expression += `'${categories[i].code}' in .attributes.categories`;
      if (i < categories.length - 1) {
        expression += " || ";
      }
    }
    const { data } = await axiosDefault.post(
      `/api/task_router2/worker/getByAttributes/workspace/${workspace.id}`,
      {
        expression
      },
      {
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    return data as Worker[];
  } catch (e) {
    message.error("Falló la búsqueda de workers");
  }
};

export const fetchWorkerTwilioById = async (
  workerId: string
): Promise<Worker | undefined> => {
  try {
    const authorizationToken = await getAuthorization();
    const { data } = await axiosDefault.get(
      `/api/task_router2/worker/${workerId}`,
      {
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    return data as Worker;
  } catch (e) {
    message.error(`Falló la búsqueda del worker`);
  }
};

export const fetchWorkersActivityLogs = async (
  workerId: number
): Promise<DayTimes[] | undefined> => {
  try {
    const authorizationToken = await getAuthorization();
    const { data } = await axiosDefault.get(
      `/api/task_router2/activityLog/worker/${workerId}`,
      {
        headers: {
          Authorization: authorizationToken
        }
      }
    );
    return data as DayTimes[];
  } catch (e) {
    message.error(
      `Ocurrió un error al traer las horas del día del agente seleccionado`
    );
  }
};
